import type { RSFundPageModel } from '../api.types';

export type RuleData = {
  date_data: [string[], ...[string, string][]]; // header + fail date rows
  rule_description: string;
  rule: string;
};

/** Rules for one regulation bucket (e.g. regulatory, prospectus). */
export type FailRegulationBucket = {
  compliance_type?: string;
  [ruleKey: string]: RuleData | string | undefined;
};

/**
 * Inner `data` on fails page responses.
 * Regulation buckets are keyed (e.g. `regulatory`, `prospectus`).
 */
export type FailsPayload = {
  internal_fund_name: string;
  external_fund_name: string;
  fund_type?: string;
  regulatory?: FailRegulationBucket;
  prospectus?: FailRegulationBucket;
  [key: string]: FailRegulationBucket | string | undefined;
};

/** API response for fails pages — `RSFundPageModel` from `PageModel.to_dict()`. */
export type FailsPageModel = RSFundPageModel<FailsPayload>;

const META_KEYS = new Set([
  'internal_fund_name',
  'external_fund_name',
  'fund_type',
  'compliance_type',
]);

export function isRuleData(value: unknown): value is RuleData {
  return (
    !!value &&
    typeof value === 'object' &&
    'rule' in value &&
    'rule_description' in value &&
    'date_data' in value
  );
}

export function getRegulationBucket(
  payload: FailsPayload | null | undefined,
  key: string,
): FailRegulationBucket {
  const value = payload?.[key];
  if (!value || typeof value !== 'string') {
    return (value as FailRegulationBucket) ?? {};
  }
  return {};
}

export function isFailsMetaKey(key: string): boolean {
  return META_KEYS.has(key);
}
